// assets
import { IconUser, IconHeartRateMonitor, IconGraph, IconCalendarTime, IconCalendarStats } from '@tabler/icons';
import { createChildGroupMenuItem, createChildMenuItem, createMenuItem } from 'utils/menu';

// ==============================|| STUDENT MENU ITEMS ||============================== //

const student = [
  createMenuItem('calon', 'student.read', 'Calon Murid', '/student/draft', IconUser, false),
  createMenuItem('nego', 'student.read', 'Calon Murid Nego', '/student/nego', IconUser, false),
  createMenuItem('verified', 'student.read', 'Terverifikasi', '/student/verified', IconUser, false),
  createMenuItem('unpaid', 'student.read', 'Menunggu Pembayaran', '/student/unpaid', IconUser, false),
  createMenuItem('pending', 'student.read', 'Pending', '/student/pending', IconUser, false),
  createMenuItem('gradeup', 'student.read', 'Proses Naik Kelas', '/student/grade-up', IconUser, false),
  createMenuItem('active', 'student.read', 'Aktif', '/student/active', IconUser, false),
  createMenuItem('inactive', 'student.read', 'Murid Non Aktif', '/student/inactive', IconUser, false),
  createMenuItem('birthday', 'student.read', 'Murid Sedang Berulang Tahun', '/student-birthday', IconUser, false),
];

const studyhistory = [
  createMenuItem('studyhistory', 'studyhistory.read', 'Riwayat Belajar', '/learning/history', IconHeartRateMonitor, false),
  createMenuItem('examschedule', 'examschedule.read', 'Jadwal Ujian', '/exam/schedule', IconCalendarTime, false),
  createMenuItem('examscores', 'examschedule.read', 'Nilai Ujian', '/exam/scores', IconCalendarStats, false)
];

const children = [
  {
    id: 'student',
    perm: 'student.read',
    title: 'Data Murid',
    type: 'collapse',
    icon: IconUser,
    children: createChildMenuItem(student)
  },
  {
    id: 'code',
    perm: 'student.code',
    title: 'Kode Akses Murid',
    type: 'item',
    url: '/student/code',
    icon: IconUser,
    breadcrumbs: false
  },
  {
    id: 'studyhistory',
    title: 'Hasil Belajar Murid',
    type: 'collapse',
    icon: IconGraph,
    children: createChildMenuItem(studyhistory)
  }
];

const data = {
  id: 'student',
  title: '',
  type: 'group',
  children: createChildGroupMenuItem(children)
};

export default data;
